const state = {
    address: {
        delivery: {
            line1: '',
            line2: '',
            city: '',
            postcode: '',
            country: '',
            county: '',
            contact_number: ''
        },
        billing: {
            line1: '',
            line2: '',
            city: '',
            postcode: '',
            country: '',
            county: '',
            contact_number: ''
        }
    },
    addresses: [],
    adding_address: false,
    active_delivery: null,
    default_delivery: null
};


const getters = {
    address: state => state.address,
    addresses: state => state.addresses,
    delivery_address: state => state.address.delivery,
    active_delivery: state => state.active_delivery,
    default_delivery: state => state.default_delivery,
    billing_address: state => state.address.billing,
    adding_address: state => state.adding_address,
};

const actions = {
    setAddress({commit}, payload) {
        commit('SET_ADDRESS', payload)
    },
    setDeliveryAddress({commit}, payload) {
        commit('SET_DELIVERY_ADDRESS', payload)
    },
    updateDeliveryAddress({commit}, payload) {
        commit('UPDATE_DELIVERY_ADDRESS', payload)
    },
    addingAddress({commit}, payload) {
        commit('ADDING_ADDRESS', payload)
    },
    setBillingAddress({commit}, payload) {
        commit('SET_BILLING_ADDRESS', payload)
    },
    updateBillingAddress({commit}, payload) {
        commit('UPDATE_BILLING_ADDRESS', payload)
    }
};

// mutations
const mutations = {
    SET_ADDRESS(state, payload) {
        state.address[payload.type][payload.name] = payload.value;
    },
    SET_ADDRESSES(state, payload) {
        state.addresses = payload;

        if (payload.length) {
            let defaultAddress = payload.find(x => x.default_delivery === 1);

            if (defaultAddress && defaultAddress.length > 0) {
                state.default_delivery = defaultAddress.id;
            }
        }
    },
    SET_DELIVERY_ADDRESS(state, payload) {
        state.address.delivery = payload;
    },
    ADD_ADDRESS(state, payload) {
        state.addresses.push(payload);
    } ,
    UPDATE_DELIVERY_ADDRESS(state, payload) {
        state.address.delivery.line1 = payload.line1;

        if (payload.line2) {
            state.address.delivery.line2 = payload.line2;
        } else {
            state.address.delivery.line2 = null;
        }

        state.address.delivery.city = payload.city;
        state.address.delivery.county = payload.county;
        state.address.delivery.postcode = payload.postcode;
        state.address.delivery.country = payload.country;
    },
    SET_ACTIVE_DELIVERY_ADDRESS(state, payload) {
        state.active_delivery = payload;
    },
    DELETE_ADDRESS(state, id) {
        state.addresses = state.addresses.filter(address => address.id !== id);
    },
    ADDING_ADDRESS(state, payload) {
        state.adding_address = payload;
    },
    SET_BILLING_ADDRESS(state, payload) {
        state.address.billing = payload;
    },
    UPDATE_BILLING_ADDRESS(state, payload) {
        state.address.billing.id = payload.id;
        state.address.billing.line1 = payload.line1;

        if (payload.line2) {
            state.address.billing.line2 = payload.line2;
        } else {
            state.address.billing.line2 = null;
        }

        state.address.billing.city = payload.city;
        state.address.billing.county = payload.county;
        state.address.billing.postcode = payload.postcode;
        state.address.billing.country = payload.country;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
